import { render, staticRenderFns } from "./ValkyrieTab.vue?vue&type=template&id=284abd7a&scoped=true&"
import script from "./ValkyrieTab.vue?vue&type=script&lang=js&"
export * from "./ValkyrieTab.vue?vue&type=script&lang=js&"
import style0 from "./ValkyrieTab.vue?vue&type=style&index=0&id=284abd7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284abd7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VIcon,VTab})
